import type { NeedsAttentionEntry } from '@/types/analytics';
import { formatDateTime } from '@/lib/utils';
import { LeaderboardTable } from './leaderboard-table';

interface NeedsAttentionTableProps {
  rows: NeedsAttentionEntry[];
}

export function NeedsAttentionTable({ rows }: NeedsAttentionTableProps) {
  return (
    <LeaderboardTable<NeedsAttentionEntry>
      rows={rows}
      getKey={(r) => r.student_id}
      getHref={(r) => `/students/${r.student_id}`}
      emptyLabel="All cohort students are active"
      columns={[
        {
          header: 'Student',
          cell: (r) => (
            <span className="font-medium">
              {r.display_name || r.username || '—'}
            </span>
          ),
        },
        {
          header: 'Last session',
          cell: (r) =>
            r.last_session_at ? (
              formatDateTime(r.last_session_at)
            ) : (
              <span className="text-muted-foreground">Never</span>
            ),
        },
        {
          header: 'Inactive',
          cell: (r) =>
            r.days_inactive < 0 ? '—' : `${r.days_inactive}d`,
          className: 'text-right tabular-nums',
        },
      ]}
    />
  );
}
